import React, { Component } from 'react';
import PropTypes from "prop-types";
import EventPublisher from "../../utils/EventPublisher";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";
import Time from "../../utils/Time";
import ImageCarouselView from "./ImageCarouselView";
import Money from "../../utils/Money";
import Text from "../../utils/Text";

export default class ListedSpacesTableView extends Component {

    static propTypes = {
        spaces: PropTypes.arrayOf(PropTypes.shape({
            spaceId: PropTypes.number.isRequired,
            title: PropTypes.string.isRequired,
            description: PropTypes.string.isRequired,
            pricePerDay: PropTypes.number.isRequired,
            minimumDays: PropTypes.number.isRequired,
            distance: PropTypes.number.isRequired,
            created: PropTypes.number.isRequired,
            imageNames: PropTypes.arrayOf(PropTypes.string).isRequired,
        }))
    };

    render() {
        if (this.props.spaces.length === 0) {
            return (
                <div className="text-muted text-center mt-5 mb-5">
                    You currently don't have any unlisted Spaces.
                    <br/>
                    Unlisted Spaces are not searchable by others.
                </div>
            );
        }

        return (
            <div className="d-flex align-content-stretch flex-wrap">
                {
                    this.props.spaces.map((space) => {
                        return (
                            <div className="col-xs-12 col-md-6 col-lg-4 pt-2" key={"Space-"+space.spaceId}>
                                <div className="card rounded h-100">
                                    <ImageCarouselView imageNames={space.imageNames} id={space.spaceId} viewHeightSize={25}/>
                                    <div className="card-body border-top-box" id={space.spaceId}>
                                        <div className="row mb-0">
                                            <div className="col-8">
                                                <button
                                                    type="button"
                                                    className="btn btn-link pl-0 pr-0"
                                                    onClick={(e) => this.handlePreviewSpaceClick(space.spaceId)}
                                                >
                                                    <h6 className="card-title bold-contents-text">
                                                        {space.title}
                                                    </h6>
                                                </button>
                                            </div>
                                            <div className="col-4 pl-0">
                                                <div className="row ">
                                                    <div className="col text-right pl-0">
                                                        {Money.formatMoney(space.pricePerDay)} <small>/ day</small>
                                                    </div>
                                                </div>
                                                <div className="row card-subtitle">
                                                    <div className="col text-right">
                                                        <small>
                                                            min. {space.minimumDays} days
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row justify-content-center">
                                            Created:
                                            <span className="pl-2">
                                                {this._convertTimeStampToReadableDateTime(space.created)}
                                            </span>
                                        </div>
                                        <div className="row">
                                            <p className="card-text text-muted">{Text.truncate(space.description, 100, true)}</p>
                                        </div>
                                    </div>
                                    <div className="card-footer p-0">
                                        <div className="btn-group w-100">
                                            <button
                                                type="button"
                                                className="btn btn-cuvered-pink"
                                                onClick={(e) => this.handleEditSpaceClick(space.spaceId)}
                                            >
                                                <i className="fas fa-edit mr-1" />
                                                Edit
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-cuvered-dark-blue"
                                                onClick={(e) => this.handleManageSpaceClick(space.spaceId)}
                                            >
                                                <i className="fas fa-calendar-alt mr-1" />
                                                Manage
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-primary"
                                                onClick={(e) => this.handleListSpaceClick(space.spaceId)}
                                            >
                                                <i className="fas fa-eye mr-1" />
                                                List
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        );
    }

    handlePreviewSpaceClick = (spaceId) => {
        EventPublisher.publish(UIInteractionEvents.MY_SPACES_SPACE_PREVIEW_BUTTON_CLICKED, {spaceId: spaceId});
    };

    handleEditSpaceClick = (spaceId) => {
        EventPublisher.publish(UIInteractionEvents.MY_SPACES_EDIT_SPACE_BUTTON_CLICKED, {spaceId: spaceId});
    };

    handleManageSpaceClick = (spaceId) => {
        EventPublisher.publish(UIInteractionEvents.MY_SPACES_MANAGE_SPACE_BUTTON_CLICKED, {spaceId: spaceId});
    };

    handleListSpaceClick = (spaceId) => {
        EventPublisher.publish(UIInteractionEvents.MY_SPACES_LIST_SPACE_BUTTON_CLICKED, {spaceId: spaceId});
    };

    _convertTimeStampToReadableDateTime(timeStamp) {
        return Time.parseDateFromTimestamp(timeStamp).toLocaleString('en-US');
    }
}

